import { DataGrid, List, LoadPanel, SelectBox } from "devextreme-react";
import {
  Column,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
  Lookup,
  Editing,
} from "devextreme-react/data-grid";
import React, {
  memo,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import Modal from "react-modal";
import DropDownBox from "devextreme-react/drop-down-box";
import DxPopup, { ToolbarItem } from "devextreme-react/popup";
import { DateFormat, RegEx } from "../../helpers/fixcodes";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Map as LeafletMap, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import PlaceSearchComponent from "../Shared/PlaceSearchComponent";
import { useMemo } from "react";
import DataSource from "devextreme/data/data_source";
import {
  askConfirmation,
  showResponseMessageWithErrorInToast,
} from "../../helpers/message";
import { axiosGet, axiosPost } from "../../apis/useAxios";
import UserActivityHistoryComponent from "../Shared/UserActivityHistoryComponent";
import SetDefaultHotelComponent from "../Shared/SetDefaultHotelComponent.js";

// Hoisted to module scope so the grid's column templates keep a stable
// identity across re-renders — new function props make devextreme-react
// rebuild the columns and visibly repaint the grid on every state change.
function renderStatusBadgeCell(data) {
  const isActive = /^active$/i.test((data.value ?? "").toString().trim());
  return (
    <span className={`nfal-status-badge ${isActive ? "active" : "inactive"}`}>
      <span className="dot" />
      {data.value}
    </span>
  );
}
function renderAirportCodeCell(data) {
  const airports = data.data.mappedAirports || [];
  const skipAirports = airports.filter(
    (a) => a.skipTransportOnFlightArrivalDuty,
  );
  return (
    <div>
      {data.value}
      {skipAirports.map((a) => (
        <div
          key={a.airportCode}
          style={{ fontSize: 11, color: "#1e7a45", marginTop: 2 }}
        >
          <i className="fas fa-check-circle" style={{ marginRight: 4 }} />
          {a.airportCode}: Skip transport on arrival flight
        </div>
      ))}
    </div>
  );
}

export default function NonFlyActivityLocationComponent() {
  const [state, setState] = useState({
    loadPanelVisible: false,
    filterDropdownAirportDataSource: [],
    filterAirportCode: "",
    nonFlyActivityLocationGridDataSource: [],
    openActivityLocationModal: false,
    openActivityLocationMappingModal: false,
    locationCode: "",
    mappedAirportCodes: [],
    historyModal: {
      openModal: false,
      airlineCode: "",
      locationCode: "",
      displayTitle: "",
    },
    isSetDefaultHotelModalOpen: false,
    rowData: null,
  });
  // Full-text preview popup for truncated AddressTitle/Address grid cells.
  // Kept out of `state` and set only via the stable setter below so the
  // cellRender callbacks' identity never changes (avoids repainting the grid).
  const [previewText, setPreviewText] = useState(null); // { title, text } | null
  const renderAddressTitleCell = useCallback((cellData) => {
    const fullText =
      cellData.value == null ? "" : String(cellData.value).trim();
    return (
      <span>
        {fullText.length > 30 && (
          <>
            {fullText.slice(0, 27) + "..."}
            <i
              className="fas fa-info-circle"
              title="View full Address Title"
              style={{
                marginLeft: 6,
                color: "#5B3FD6",
                cursor: "pointer",
                fontSize: 12,
              }}
              onClick={() =>
                setPreviewText({ title: "Address Title", text: fullText })
              }
            />
          </>
        )}
        {fullText.length <= 30 && fullText}
      </span>
    );
  }, []);
  const renderAddressCell = useCallback((cellData) => {
    const fullText =
      cellData.value == null ? "" : String(cellData.value).trim();

    return (
      <div className="mergeData ellipsis">
        <span className="text-danger">
          <i className="fas fa-map-marker-alt"></i>
        </span>
        <span className="text-muted"></span> {"  "}
        {fullText.length > 50 && (
          <>
            {fullText.slice(0, 47) + "..."}
            <i
              className="fas fa-info-circle"
              title="View full Address"
              style={{
                marginLeft: 6,
                color: "#5B3FD6",
                cursor: "pointer",
                fontSize: 12,
              }}
              onClick={() =>
                setPreviewText({ title: "Address", text: fullText })
              }
            />
          </>
        )}
        {fullText.length <= 50 && fullText}
        <br />
        <span className="text-success">
          <i className="fas fa-map-marker-alt"></i>
        </span>
        <span className="text-muted"></span>
        {"  "}
        <a
          href="#"
          title="Navigate to maps"
          onClick={(e) => {
            e.preventDefault();
            window.open(
              `https://maps.google.com?q=${cellData.data.latitude} , ${cellData.data.longitude}`,
            );
          }}
        >
          {" "}
          {`${cellData.data.latitude} , ${cellData.data.longitude}`}
        </a>
      </div>
    );
  }, []);
  const renderLandmarkCell = useCallback((cellData) => {
    const fullText =
      cellData.value == null ? "" : String(cellData.value).trim();
    return (
      <span>
        {fullText.length > 21 && (
          <>
            {fullText.slice(0, 18) + "..."}
            <i
              className="fas fa-info-circle"
              title="View landmark"
              style={{
                marginLeft: 6,
                color: "#5B3FD6",
                cursor: "pointer",
                fontSize: 12,
              }}
              onClick={() =>
                setPreviewText({ title: "Landmark", text: fullText })
              }
            />
          </>
        )}
        {fullText.length <= 21 && fullText}
      </span>
    );
  }, []);
  const refDataGrid = useRef(null);
  useLayoutEffect(() => {
    document.querySelector("#lblPageTitle").innerHTML =
      `Crew - Non Fly Activity Location`;
  }, []);
  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetGridDataOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);
  const fetGridDataOnPageLoad = () => {
    try {
      setTimeout(() => {
        getDropdownAirportDataSource();
      }, 0);
      setTimeout(async () => {
        await getNonFlyActivityLocationList();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  const getDropdownAirportDataSource = useCallback(async () => {
    try {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));
      const res = await axiosGet(
        `Airport/get-airport-dropdown/${sessionStorage.getItem(
          "session_airlineCode",
        )}`,
      );
      setState((prev) => ({
        ...prev,
        filterDropdownAirportDataSource: res?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
      }));
    }
  }, []);
  const getNonFlyActivityLocationList = async () => {
    try {
      refDataGrid.current.instance.beginCustomLoading();
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let airportCode = state.filterAirportCode ?? "";
      let resp = await axiosPost(
        "CrewActivity/get-non-fly/activity-locations",
        {
          AirlineCode: airlineCode,
          AirportCode: airportCode,
        },
      );
      setState((prev) => ({
        ...prev,
        nonFlyActivityLocationGridDataSource: resp?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid.current.instance.endCustomLoading();
    }
  };

  const resyncFixedColumnRowHeights = useCallback((e) => {
    // React cell templates (2-line Address, action icons) fill in after
    // DevExtreme has measured row heights, leaving the fixed action column
    // misaligned. Re-sync only while heights actually differ so this
    // self-terminates and cannot loop via contentReady.
    setTimeout(() => {
      try {
        const fixedRows = e.element.querySelectorAll(
          ".dx-datagrid-content-fixed .dx-data-row",
        );
        const mainRows = e.element.querySelectorAll(
          ".dx-datagrid-content:not(.dx-datagrid-content-fixed) .dx-data-row",
        );
        const mismatch = [...fixedRows].some(
          (row, i) =>
            mainRows[i] &&
            Math.abs(row.offsetHeight - mainRows[i].offsetHeight) > 1,
        );
        if (mismatch) {
          e.component.updateDimensions();
        }
      } catch (error) {
        console.log(error);
      }
    }, 150);
  }, []);

  const handleOnCloseSetDefaultHotelModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isSetDefaultHotelModalOpen: false,
        rowData: null,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const renderGridCell = useCallback((data) => {
    let updateLink = (
      <a
        href="#"
        // className="btn-link"
        title="Update Activity Location"
        onClick={(e) => {
          e.preventDefault();
          setState((prev) => ({
            ...prev,
            openActivityLocationModal: true,
            locationCode: data.data.locationCode,
          }));
        }}
      >
        <i
          style={{
            cursor: "pointer",
            marginLeft: "0px",
          }}
          className="fas fa-edit"
        />
      </a>
    );
    let mappingLink = (
      <a
        href="#"
        // className="btn-link"
        title="Update Activity Location Mapping"
        onClick={(e) => {
          e.preventDefault();
          setState((prev) => ({
            ...prev,
            openActivityLocationMappingModal: true,
            locationCode: data.data.locationCode,
            mappedAirportCodes: data.data.mappedAirportCodes,
          }));
        }}
      >
        <i
          style={{
            cursor: "pointer",
            marginLeft: `${updateLink ? "6px" : "0px"}`,
          }}
          className="fas fa-cog"
        />
      </a>
    );
    let setDefaultLink = (
      <a
        href="#"
        // className="btn-link"
        title="Set Default Link"
        onClick={(e) => {
          e.preventDefault();
          setState((prev) => ({
            ...prev,
            isSetDefaultHotelModalOpen: true,
            rowData: data?.data,
          }));
        }}
      >
        <i
          style={{
            cursor: "pointer",
            marginLeft: `${mappingLink ? "6px" : "0px"}`,
          }}
          className="fas fa-hotel"
        />
      </a>
    );

    let activityHistory = (
      <a
        href="#"
        // className="btn-link"
        title="Log"
        onClick={(e) => {
          e.preventDefault();
          setState((prev) => ({
            ...prev,
            historyModal: {
              openModal: true,
              airlineCode: data.data.airlineCode,
              locationCode: data.data.locationCode,
              displayTitle: data.data.locationCode,
            },
          }));
        }}
      >
        <i
          style={{
            cursor: "pointer",
            marginLeft: `${setDefaultLink ? "6px" : "0px"}`,
          }}
          className="fas fa-exclamation-circle"
        />
      </a>
    );

    return (
      <div className="nfal-action-links" style={{ textAlign: "left" }}>
        {updateLink}
        {mappingLink}
        {setDefaultLink}
        {activityHistory}
      </div>
    );
  }, []);

  // The whole grid element is memoized so unrelated state changes (opening
  // a modal, changing the airport filter) re-use the identical React element
  // and never reach devextreme-react's option diffing — which repaints the
  // grid (visible blink) on every parent re-render otherwise.
  const dataGridElement = useMemo(() => {
    return (
      <DataGrid
        ref={refDataGrid}
        dataSource={state.nonFlyActivityLocationGridDataSource}
        columnsAutoWidth={true}
        showColumnLines={true}
        showRowLines={true}
        showBorders={true}
        rowAlternationEnabled={false}
        allowColumnResizing={true}
        repaintChangesOnly={true}
        onContentReady={resyncFixedColumnRowHeights}
      >
        <Column
          dataField="rowIndex"
          caption=""
          allowSorting={false}
          allowSearch={false}
          allowExporting={false}
          allowFiltering={false}
          cellRender={renderGridCell}
          fixed={true}
          //width={85}
          minWidth={"85"}
          width={"auto"}
        />
        <Column
          dataField="locationCode"
          caption="Location Code"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          //width={150}
          minWidth={150}
          width={"auto"}
        />
        <Column
          dataField="airportCode"
          caption="Airport Code"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          //width={200}
          minWidth={"140"}
          width={"auto"}
          cellRender={renderAirportCodeCell}
        />
        <Column
          dataField="addressTitle"
          caption="Address Title"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          width={200}
          //cellRender={renderAddressTitleCell}
        />
        <Column
          dataField="address"
          caption="Address"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          width={350}
          cellRender={renderAddressCell}
        />
        <Column
          dataField="landmark"
          caption="Landmark"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          width={150}
          //cellRender={renderLandmarkCell}
        />
        <Column
          dataField="city"
          caption="City"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          width={100}
        />
        <Column
          dataField="state"
          caption="State"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          width={100}
        />
        <Column
          dataField="country"
          caption="Country"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          width={100}
        />
        <Column
          dataField="postalCode"
          caption="Postal Code"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          width={100}
        />
        <Column
          dataField="activeStatus"
          caption="Status"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          width={100}
          cellRender={renderStatusBadgeCell}
        />
        <Column
          dataField="modifiedDate"
          caption="Date"
          allowSearch={true}
          headerFilter={{ allowSearch: true }}
          format={DateFormat.DateTime24NorthFormat}
          dataType="datetime"
          width={100}
        />
        <SortByGroupSummaryInfo summaryItem="count" />
        <GroupPanel visible={false} />
        <HeaderFilter visible={true} />
        <SearchPanel
          visible={true}
          highlightCaseSensitive={true}
          width={240}
          placeholder="Search..."
        />
        <Grouping autoExpandAll={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50]}
          showInfo={true}
          visible={true}
        />
        <Export
          enabled={true}
          allowExportSelectedData={false}
          fileName="NonFlyActivityLocation"
        />
      </DataGrid>
    );
  }, [
    state.nonFlyActivityLocationGridDataSource,
    resyncFixedColumnRowHeights,
    renderGridCell,
    renderAddressTitleCell,
    renderAddressCell,
  ]);
  return (
    <>
      <style>{`
        /* ── Non Fly Activity Location — theme matching sidebar #8E6448 ── */
        .nfal-preview-popup .dx-popup-title {
          background: linear-gradient(135deg, #8E6448 0%, #a97c5b 100%);
          color: #ffffff;
          padding: 12px 20px;
        }
        .nfal-preview-popup .dx-popup-title .dx-toolbar-label > div {
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0.02em;
          color: #ffffff;
        }
        .nfal-preview-popup .dx-popup-title .dx-closebutton .dx-icon {
          color: #ffffff;
        }
        .nfal-preview-popup .dx-popup-content {
          background: #fffdfb;
          padding: 0;
        }
        .nfal-preview-popup-body {
          padding: 18px 20px;
          font-size: 14px;
          line-height: 1.6;
          color: #4a3a2c;
          word-break: break-word;
          white-space: pre-wrap;
        }
        .nfal-preview-popup .dx-popup-bottom.dx-toolbar {
          background: #f5ede4;
          border-top: 1px solid #e3d5c6;
          padding: 4px 10px;
          min-height: 36px;
        }
        .nfal-preview-popup .dx-popup-bottom .dx-toolbar-items-container {
          height: 30px;
        }
        .nfal-preview-popup .dx-popup-bottom .dx-button.dx-button-mode-contained.dx-button-default {
          background-color: #8E6448;
          border-color: #8E6448;
          min-width: 60px;
          height: 26px;
          font-size: 12px;
        }
        .nfal-preview-popup .dx-popup-bottom .dx-button.dx-button-mode-contained.dx-button-default .dx-button-text {
          font-size: 12px;
        }
        .nfal-preview-popup .dx-popup-bottom .dx-button.dx-button-mode-contained.dx-button-default:hover {
          background-color: #7a5540;
        }
        .nfal-filter-card {
          background: #ffffff;
          border: none;
          border-radius: 10px;
          box-shadow: 0 2px 12px rgba(142,100,72,0.12);
          padding: 0 !important;
          overflow: hidden;
        }
        .nfal-filter-body {
          padding: 0.6rem !important;
        }
        .nfal-filter-body label {
          font-size: 0.7rem;
          font-weight: 600;
          color: #8E6448;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          margin-bottom: 0.2rem;
          display: block;
        }
        .nfal-filter-body .dx-texteditor.dx-editor-outlined {
          border: 1px solid #e3d5c6;
          border-radius: 6px;
          background: #fffdfb;
        }
        .nfal-filter-body .dx-texteditor.dx-editor-outlined.dx-state-hover {
          border-color: #d9c3aa;
        }
        .nfal-filter-body .dx-texteditor.dx-editor-outlined.dx-state-focused,
        .nfal-filter-body .dx-texteditor.dx-editor-outlined.dx-state-focused.dx-state-hover {
          border-color: #f4691e;
          box-shadow: none;
        }
        .nfal-filter-body .dx-texteditor-input {
          padding-top: 5px;
          padding-bottom: 5px;
          min-height: 29px;
          font-size: 0.8rem;
        }
        .filter-box {
          margin-bottom: 0px;
        }
        .nfal-filter-row {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          gap: 0.75rem;
        }
        .nfal-filter-field {
          flex: 0 1 310px;
          min-width: 200px;
        }
        .nfal-filter-actions {
          display: flex;
          gap: 0.5rem;
          flex-shrink: 0;
          flex-wrap: wrap;
          white-space: nowrap;
          /* offset equal to the field labels so buttons line up with the inputs */
          padding-top: 20px;
        }
        .nfal-filter-actions-right {
          margin-left: auto;
        }
        .nfal-filter-actions .btn {
          height: 30px;
          display: inline-flex;
          align-items: center;
          padding-top: 0;
          padding-bottom: 0;
          border-radius: 6px;
          box-sizing: border-box;
        }
        .nfal-status-badge {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 2px 10px;
          border-radius: 20px;
          font-size: 0.72rem;
          font-weight: 600;
          letter-spacing: 0.02em;
        }
        .nfal-status-badge.active {
          background: #e6f4ea;
          color: #1e5631;
        }
        .nfal-status-badge.inactive {
          background: #f0ebe6;
          color: #8a7060;
        }
        .nfal-status-badge .dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: currentColor;
        }
        .nfal-action-links a {
          color: #8E6448;
          transition: color 0.15s ease;
        }
        .nfal-action-links a:hover {
          color: #f4691e;
        }

        .nfal-grid-wrap {
          margin-bottom: 0;
        }
        .nfal-grid-wrap > .card-body {
          padding: 0.6rem !important;
        }
        .nfal-grid-wrap .dx-header-row td {
          background-color: #fff0e6 !important;
          color: #000000 !important;
          font-size: 0.76rem !important;
          font-weight: 600 !important;
          letter-spacing: 0.02em !important;
          border-color: rgba(255,255,255,0.15) !important;
        }
        .nfal-grid-wrap .dx-datagrid-filter-row td {
          background-color: #f5ede4 !important;
        }
        .nfal-grid-wrap .dx-datagrid {
          border-radius: 8px !important;
          overflow: hidden !important;
          box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
        }
        .nfal-grid-wrap .dx-toolbar {
          background: #fdf7f2 !important;
          border-bottom: 1px solid #e8d5c4 !important;
          padding: 0.4rem 0.6rem !important;
        }
        .dx-datagrid-header-panel .dx-toolbar {
          margin-bottom: 5px !important;
        }

        /* tablet */
        @media (max-width: 991px) {
          .nfal-filter-field {
            flex: 1 1 260px;
          }
        }
        /* mobile */
        @media (max-width: 576px) {
          .nfal-filter-field,
          .nfal-filter-actions,
          .nfal-filter-actions-right {
            flex-basis: 100%;
            min-width: 100%;
            margin-left: 0;
          }
          .nfal-filter-actions {
            justify-content: flex-start;
            padding-top: 0;
          }
          .nfal-filter-actions .btn {
            flex: 1 1 auto;
            justify-content: center;
          }
        }
      `}</style>

      <div className="filter-box">
        <div className="card nfal-filter-card p-0 m-0">
          <div className="nfal-filter-body">
            <div className="nfal-filter-row">
              <div className="nfal-filter-field">
                <div className="form-group mb-0">
                  <label>Airport</label>
                  <SelectBox
                    dataSource={state.filterDropdownAirportDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="All Airports"
                    name="airportCode"
                    value={state.filterAirportCode}
                    displayExpr="airportName"
                    valueExpr="airportCode"
                    width="100%"
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onValueChanged={(e) => {
                      setState((prev) => ({
                        ...prev,
                        filterAirportCode: e.value ?? "",
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="nfal-filter-actions">
                <button
                  type="button"
                  title="Search Location"
                  className="btn btn-primary btn-sm"
                  onClick={async () => {
                    await getNonFlyActivityLocationList();
                  }}
                >
                  <span title="Search">
                    <i className="fas fa-search" />
                    &nbsp;Search
                  </span>
                </button>
              </div>
              <div className="nfal-filter-actions nfal-filter-actions-right">
                <button
                  type="button"
                  title="Add Location"
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    setState((prev) => ({
                      ...prev,
                      openActivityLocationModal: true,
                    }));
                  }}
                >
                  <i className="fas fa-plus" />
                  &nbsp;Add Location
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end filter-box */}

      <div className="card nfal-grid-wrap">
        <div className="card-body">
          <div>{dataGridElement}</div>
        </div>
      </div>

      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: "#historydiv" }}
        visible={state.loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        closeOnOutsideClick={false}
      />

      {state.openActivityLocationModal && (
        <SaveActivityLocationComponent
          locationCode={state.locationCode}
          onRefresh={async () => {
            await getNonFlyActivityLocationList();
          }}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openActivityLocationModal: false,
              locationCode: "",
            }));
          }}
        />
      )}

      {state.openActivityLocationMappingModal && (
        <SaveActivityLocationMappingModal
          locationCode={state.locationCode}
          mappedAirportCodes={state.mappedAirportCodes}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openActivityLocationMappingModal: false,
            }));
          }}
        />
      )}

      {state.historyModal.openModal && (
        <UserActivityHistoryComponent
          airlineCode={state.historyModal.airlineCode}
          displayTitle={state.historyModal.displayTitle}
          columnValue1={state.historyModal.locationCode}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              historyModal: {
                openModal: false,
                airlineCode: "",
                displayTitle: "",
                hotelCode: "",
              },
            }));
          }}
        />
      )}

      {state.isSetDefaultHotelModalOpen && (
        <SetDefaultHotelComponent
          code={state.rowData?.locationCode}
          fromAirport={false}
          rowData={state.rowData}
          onRefresh={async () => {
            await getNonFlyActivityLocationList();
          }}
          onClose={() => {
            handleOnCloseSetDefaultHotelModal();
          }}
        />
      )}

      <DxPopup
        visible={!!previewText}
        onHiding={() => setPreviewText(null)}
        title={previewText?.title}
        showCloseButton={true}
        dragEnabled={false}
        hideOnOutsideClick={true}
        width={420}
        height="auto"
        maxHeight="70vh"
        deferRendering={false}
        wrapperAttr={{ class: "nfal-preview-popup" }}
      >
        <div className="nfal-preview-popup-body">{previewText?.text}</div>
        <ToolbarItem
          toolbar="bottom"
          location="after"
          widget="dxButton"
          options={{
            text: "Close",
            type: "default",
            stylingMode: "contained",
            onClick: () => setPreviewText(null),
          }}
        />
      </DxPopup>
    </>
  );
}
const SaveActivityLocationComponent = memo((props) => {
  const [mappedAirportCodes, setMappedAirportCodes] = useState([]);
  // airportCode -> bool, keyed independently of selection since it's a per-airport flag, not the mapping checkbox itself.
  const [skipTransportFlags, setSkipTransportFlags] = useState({});
  const [state, setState] = useState({
    loadPanelVisible: false,
    dropdownAirportDataSource: [],
    dutyLocatonId: 0,
    locationCode: "",
    addressTitle: "",
    address: "",
    landmark: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    latitude: 0.7893,
    longitude: 113.9213,
    errors: {
      airportCode: "",
      locationCode: "",
      addressTitle: "",
      address: "",
      landmark: "",
      city: "",
      state: "",
      country: "",
      postalCode: "",
      latitude: "",
      longitude: "",
    },
    isLocationSubmitted: false,
    openGooglePlaceSearchModal: false,
  });
  const center = useMemo(
    () => ({
      lat: state.latitude,
      lng: state.longitude,
    }),
    [state.latitude, state.longitude],
  );
  const refLstAirport = useRef(null);
  const getDropdownAirportDataSource = async () => {
    let airportCodeDropdownLst = [];
    try {
      const res = await axiosGet(
        `Airport/get-airport-dropdown/${sessionStorage.getItem(
          "session_airlineCode",
        )}`,
      );
      airportCodeDropdownLst = [...new Set(res?.payload ?? [])];
    } catch (error) {
      console.log(error);
    }
    return airportCodeDropdownLst;
  };
  const fetchApiOnPageLoad = async () => {
    try {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));
      let airportCodeDropdownLst = await getDropdownAirportDataSource();
      let data = null;
      if (props.locationCode) {
        let airlineCode = sessionStorage.getItem("session_airlineCode");
        let res = await axiosPost(
          "CrewActivity/get-non-fly/activity-locations",
          {
            AirlineCode: airlineCode,
            LocationCode: props.locationCode ?? "",
          },
        );
        data = res?.payload?.[0] ?? null;
      }
      let mappedAirportCodes =
        data?.mappedAirportCodes?.map((code) => code.trim()) ?? [];

      let loadedSkipTransportFlags = {};
      (data?.mappedAirports ?? []).forEach((a) => {
        loadedSkipTransportFlags[a.airportCode.trim()] =
          a.skipTransportOnFlightArrivalDuty === true;
      });
      setSkipTransportFlags(loadedSkipTransportFlags);

      let mappedAirportCodeLst = [
        ...new Set(
          mappedAirportCodes.map((code) => {
            return {
              airportCode: code.trim(),
              airportName:
                airportCodeDropdownLst.filter(
                  (el) => el.airportCode.trim() === code.trim(),
                )?.[0]?.airportName ?? "",
              isMapped: 1,
            };
          }),
        ),
      ];
      let unMappedAirportCodeLst = [
        ...new Set(
          airportCodeDropdownLst
            .filter((el) => {
              return !mappedAirportCodes.find((code) => {
                return code.trim() === el.airportCode.trim();
              });
            })
            .map((item) => ({
              ...item,
              isMapped: 0,
            })),
        ),
      ];
      let airportCodeDropdown = [
        ...mappedAirportCodeLst,
        ...unMappedAirportCodeLst,
      ];
      setMappedAirportCodes(mappedAirportCodes);
      setState((prev) => ({
        ...prev,
        dropdownAirportDataSource: airportCodeDropdown,
        dutyLocatonId: data?.rowIndex ?? 0,
        locationCode: data?.locationCode ?? "",
        addressTitle: data?.addressTitle ?? "",
        address: data?.address ?? "",
        landmark: data?.landmark ?? "",
        city: data?.city ?? "",
        state: data?.state ?? "",
        country: data?.country ?? "",
        postalCode: data?.postalCode ?? "",
        latitude: data?.latitude ?? "",
        longitude: data?.longitude ?? "",
        errors: {
          airportCode: "",
          locationCode: "",
          addressTitle: "",
          address: "",
          landmark: "",
          city: "",
          state: "",
          country: "",
          postalCode: "",
          latitude: "",
          longitude: "",
        },
      }));
      setTimeout(() => {
        if (refLstAirport?.current?.instance) {
          refLstAirport.current.instance.option(
            "selectedItemKeys",
            mappedAirportCodes,
          );
        }
      }, 500);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
      }));
    }
  };
  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    let err = state.errors;
    switch (name) {
      case "locationCode":
        err.locationCode = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, locationCode: value }));
        }
        break;
      case "airportCode":
        err.airportCode = "";
        if (value.trim() === "" || value.length <= 10) {
          setState((prev) => ({ ...prev, airportCode: value }));
        }
        break;
      case "addressTitle":
        err.addressTitle = "";
        if (value.trim() === "" || value.length <= 100) {
          setState((prev) => ({ ...prev, addressTitle: value }));
        }
        break;
      case "landmark":
        err.landmark = "";
        if (value.trim() === "" || value.length <= 100) {
          setState((prev) => ({ ...prev, landmark: value }));
        }
        break;
      case "latitude":
        err.latitude = "";
        if (value.trim() === "" || RegEx.LatLong.test(value)) {
          setState((prev) => ({ ...prev, latitude: value }));
        }
        break;
      case "longitude":
        err.longitude = "";
        if (value.trim() === "" || RegEx.LatLong.test(value)) {
          setState((prev) => ({ ...prev, longitude: value }));
        }
        break;
      case "cityName":
        err.city = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, city: value }));
        }
        break;
      case "stateName":
        err.state = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, state: value }));
        }
        break;
      case "countryName":
        err.country = "";
        if (value.trim() === "" || value.length <= 50) {
          setState((prev) => ({ ...prev, country: value }));
        }
        break;
      case "address":
        err.address = "";
        if (value.trim() === "" || value.length <= 250) {
          setState((prev) => ({ ...prev, address: value }));
        }
        break;

      default:
        break;
    }
    setState((prev) => ({
      ...prev,
      errors: err,
    }));
  };
  const isValid = () => {
    let isValid = true;
    try {
      let loc = { ...state };
      let err = loc.errors;
      err.airportCode = "";
      err.locationCode = "";
      err.addressTitle = "";
      err.address = "";
      err.landmark = "";
      err.city = "";
      err.state = "";
      err.country = "";
      err.latitude = "";
      err.longitude = "";
      if (loc.dutyLocatonId === 0) {
        if (!loc.locationCode?.trim()) {
          isValid = false;
          err.locationCode = "Please enter location code";
        }
      }
      if (!mappedAirportCodes?.length) {
        isValid = false;
        err.airportCode = "Please select airport code";
      }
      if (!loc.addressTitle?.trim()) {
        isValid = false;
        err.addressTitle = "Please enter address title";
      }
      if (!loc.address?.trim()) {
        isValid = false;
        err.address = "Please enter the address";
      }
      if (!loc.landmark?.trim()) {
        isValid = false;
        err.landmark = "Please enter landmark";
      }
      if (!loc.city?.trim()) {
        isValid = false;
        err.city = "Please enter city";
      }
      if (!loc.state?.trim()) {
        isValid = false;
        err.state = "Please enter state";
      }
      if (!loc.country?.trim()) {
        isValid = false;
        err.country = "Please enter country";
      }
      if (!loc.latitude?.toString()?.trim()) {
        isValid = false;
        err.latitude = "Please enter latitude";
      }
      if (!loc.longitude?.toString()?.trim()) {
        isValid = false;
        err.longitude = "Please enter longitude";
      }
      loc.errors = err;
      setState((prev) => ({
        ...prev,
        loc,
      }));
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };
  const handleOnSaveCrewLocation = async (e) => {
    e.preventDefault();
    try {
      if (isValid()) {
        let confirmationQuestion =
          state.dutyLocatonId > 0
            ? `Are you sure want to update location ${state.locationCode}?`
            : `Are you sure want to add new location <strong>${state.locationCode}</strong> ?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No",
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isLocationSubmitted: true }));
        let request = {};
        request.AirlineCode = sessionStorage.getItem("session_airlineCode");
        request.Airports = mappedAirportCodes.map((code) => ({
          AirportCode: code,
          SkipTransportOnFlightArrivalDuty: skipTransportFlags[code] === true,
        }));
        request.LocationCode = state.locationCode;
        request.AddressTitle = state.addressTitle;
        request.Address = state.address;
        request.Landmark = state.landmark;
        request.City = state.city;
        request.State = state.state;
        request.Country = state.country;
        request.PostalCode = state.postalCode;
        request.Latitude = state.latitude;
        request.Longitude = state.longitude;
        request.UserName = sessionStorage.getItem("session_userName");
        const response = await axiosPost(
          `CrewActivity/${state.dutyLocatonId}/save-non-fly-activity-location`,
          request,
        );
        setState((prev) => ({ ...prev, isLocationSubmitted: false }));
        if (response?.isSuccess === undefined) {
          toast.error("Opps! Unable to save the data.", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            closeButton: false,
          });
          return;
        }
        if (response?.isSuccess) {
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: response?.message,
            allowOutsideClick: false,
          }).then(async (result) => {
            if (result.isConfirmed) {
              await props.onRefresh();
              await props.onClose();
            }
          });
        } else {
          toast.error(response?.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            closeButton: false,
          });
        }
      }
    } catch (err) {
      console.log(err);
      setState((prev) => ({ ...prev, isLocationSubmitted: false }));
    }
  };
  return (
    <div>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "50%" } }}
        onAfterOpen={async () => {
          await fetchApiOnPageLoad();
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {state.dutyLocatonId === 0
              ? "Add Activity Location"
              : `Update Activity Location [ ${state.locationCode} ] `}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Location Code <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="locationCode"
                  title="locationCode"
                  placeholder="Enter location code"
                  value={state.locationCode ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  readOnly={state.dutyLocatonId > 0 ? true : false}
                />
                {state.errors.locationCode?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.locationCode}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Airport<span className="text-danger">*</span>
                </label>
                <DropDownBox
                  value={mappedAirportCodes}
                  valueExpr="airportCode"
                  displayExpr="airportCode"
                  deferRendering={false}
                  showClearButton={true}
                  dataSource={state.dropdownAirportDataSource}
                  onValueChanged={() => {
                    setMappedAirportCodes([]);
                    setSkipTransportFlags({});
                    if (refLstAirport.current?.instance) {
                      refLstAirport.current.instance.unselectAll();
                      refLstAirport.current.instance.option("searchValue", "");
                    }
                    let err = { ...state.errors, airportCode: "" };
                    setState((prev) => ({ ...prev, errors: err }));
                  }}
                  contentRender={() => {
                    return (
                      <List
                        ref={refLstAirport}
                        //dataSource={state.dropdownAirportDataSource}
                        dataSource={
                          new DataSource({
                            store: state.dropdownAirportDataSource,
                            sort: [
                              "Position",
                              { selector: "isMapped", desc: true },
                            ],
                            sortOrder: "desc",
                            paginate: true,
                            pageSize: 10,
                          })
                        }
                        keyExpr="airportCode"
                        displayExpr="airportName"
                        searchEnabled={true}
                        searchExpr={["airportCode", "airportName"]}
                        searchMode="contains"
                        pageLoadMode="scrollBottom"
                        showSelectionControls={true}
                        selectionMode={"multiple"}
                        indicateLoading={true}
                        onSelectionChanged={() => {
                          try {
                            let err = { ...state.errors, airportCode: "" };
                            setState((prev) => ({ ...prev, errors: err }));
                            if (refLstAirport.current) {
                              setMappedAirportCodes(
                                refLstAirport?.current?.instance?.option(
                                  "selectedItemKeys",
                                ) ?? [],
                              );
                            }
                          } catch (error) {
                            console.log("onSelectionChanged", error);
                          }
                        }}
                      />
                    );
                  }}
                  placeholder="Select an item"
                />
                {state.errors.airportCode.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.airportCode}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Address Title<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="addressTitle"
                  placeholder="Enter address title"
                  value={state.addressTitle ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.addressTitle.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.addressTitle}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              {mappedAirportCodes.length > 0 && (
                <div
                  style={{
                    marginTop: 8,
                    marginBottom: 16,
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "4px 14px",
                  }}
                >
                  {mappedAirportCodes.map((code) => {
                    const airportName =
                      state.dropdownAirportDataSource.find(
                        (a) => a.airportCode === code,
                      )?.airportName ?? code;
                    return (
                      <label
                        key={code}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          fontSize: "small",
                          marginBottom: 0,
                        }}
                        title={airportName}
                      >
                        <input
                          type="checkbox"
                          checked={skipTransportFlags[code] === true}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setSkipTransportFlags((prev) => ({
                              ...prev,
                              [code]: checked,
                            }));
                          }}
                        />
                        {code} — Skip transport on flight arrival
                      </label>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Landmark<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="landmark"
                  title="landmark"
                  placeholder="Enter landmark"
                  value={state.landmark ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.landmark?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.landmark}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Latitude<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="latitude"
                  title="latitude"
                  placeholder="Enter latitude"
                  value={state.latitude ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.latitude?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.latitude}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Longitude<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="longitude"
                  title="longitude"
                  placeholder="Enter longitude"
                  value={state.longitude ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.longitude?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.longitude}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  City<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="cityName"
                  title="cityName"
                  placeholder="Enter City"
                  value={state.city ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.city?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.city}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  State<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="stateName"
                  title="stateName"
                  placeholder="Enter State"
                  value={state.state ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.state?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.state}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="form-group">
                <label>
                  Country<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="countryName"
                  title="countryName"
                  placeholder="Enter Country"
                  value={state.country ?? ""}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                />
                {state.errors.country?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.country}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div className="form-group">
                <label>Address</label>
                <div className="input-group mb-2">
                  <textarea
                    style={{ resize: "none" }}
                    className="form-control form-control-sm"
                    name="address"
                    title="address"
                    placeholder="Enter address"
                    rows={3}
                    value={state.address ?? ""}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />
                  <button
                    type="button"
                    title="Search Google"
                    className="btn btn-info"
                    onClick={() => {
                      setState((prev) => ({
                        ...prev,
                        openGooglePlaceSearchModal: true,
                      }));
                    }}
                  >
                    <i className="fab fa-google" />
                  </button>
                </div>
                {state.errors.address?.length > 0 && (
                  <span className="text-danger" style={{ fontSize: "small" }}>
                    {state.errors.address}
                  </span>
                )}
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div
                style={{
                  height: `290px`,
                  width: `100%`,
                }}
              >
                <LeafletMap
                  center={[
                    state.latitude || 28.6139,
                    state.longitude || 77.209,
                  ]}
                  zoom={16}
                  style={{ height: "100%", width: "100%" }}
                  key={`${state.latitude}-${state.longitude}`}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  />
                  {state.latitude && state.longitude && (
                    <Marker
                      position={[state.latitude, state.longitude]}
                      icon={L.icon({
                        iconUrl:
                          "https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/maps/map-marker.png",
                        iconSize: [32, 32],
                        iconAnchor: [16, 32],
                        popupAnchor: [0, -32],
                      })}
                    >
                      <Popup>{state.address}</Popup>
                    </Marker>
                  )}
                </LeafletMap>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Save"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnSaveCrewLocation(e);
            }}
          >
            <i
              className={`fas fa-${
                state.isLocationSubmitted ? "spinner fa-spin" : "check"
              }`}
            />
            &nbsp;Save
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            title="Cancel"
            className="btn btn-secondary btn-sm"
            onClick={() => {
              props.onClose();
            }}
          >
            <i className="fas fa-times" />
            &nbsp;Close
          </button>
        </div>
      </Modal>
      {state.openGooglePlaceSearchModal && (
        <PlaceSearchComponent
          optionalAutoFillAddress={state.address}
          optionalAutoFillLatitude={state.latitude}
          optionalAutoFillLongitude={state.longitude}
          onChange={(data) => {
            setState((prev) => ({
              ...prev,
              addressTitle: data?.houseApartment ?? "",
              landmark: data?.landmark ?? "",
              address: data?.address ?? "",
              city: data?.cityName ?? "",
              state: data?.stateName ?? "",
              country: data?.countryName ?? "",
              postalCode: data?.postalCode ?? "",
              latitude: data?.latitude ?? "",
              longitude: data?.longitude ?? "",
            }));
          }}
          onClose={() => {
            setState((prev) => ({
              ...prev,
              openGooglePlaceSearchModal: false,
            }));
          }}
        />
      )}
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: "#historydiv" }}
        visible={state.loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        closeOnOutsideClick={false}
      />
    </div>
  );
});

const SaveActivityLocationMappingModal = memo((props) => {
  const [state, setState] = useState({
    loadPanelVisible: false,
    isLocationMappingSubmitted: false,
    serviceProviderGridDataSource: [],
    activityLocationSettingsDataSource: [],
  });

  const fetchApiOnPageLoad = async () => {
    try {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));
      await getServiceProvider();
      await getActivityLocationSettings();
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
      }));
    }
  };

  const getServiceProvider = async () => {
    try {
      let serviceProviderGridDataSource = [];
      for (let index = 0; index < props.mappedAirportCodes.length; index++) {
        const airportCode = props.mappedAirportCodes[index];
        const data = await axiosGet("Account/get-transport-dropdown", {
          airportCode: airportCode,
        });
        if (data.payload?.length > 0) {
          for (let el of data.payload) {
            let transporter = { id: el.id, name: el.name };
            serviceProviderGridDataSource.push(transporter);
          }
        }
      }
      setState((prev) => ({
        ...prev,
        serviceProviderGridDataSource: serviceProviderGridDataSource,
      }));
    } catch (err) {
      console.log("Error in getServiceProvider function", err);
    }
  };

  const getActivityLocationSettings = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let data = await axiosGet("CrewActivity/activity-location-setting", {
        airlineCode: airlineCode,
        locationCode: props.locationCode,
      });
      setState((prev) => ({
        ...prev,
        activityLocationSettingsDataSource: data.payload ?? [],
      }));
    } catch (err) {
      console.log("Error in getActivityLocationSettings function", err);
    }
  };

  const handleOnSaveActivityLocationSettings = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      let userName = sessionStorage.getItem("session_userName");
      let confirmationQuestion =
        state.dutyLocatonId > 0
          ? `Are you sure want to update activity location setting [${props.locationCode}]?`
          : `Are you sure want to add new activity location setting <strong>[${props.locationCode}]</strong> ?`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No",
      );

      if (!isConfirmed) return;
      setState((prev) => ({ ...prev, isLocationMappingSubmitted: true }));

      let activityLocationMappingData = [
        ...new Set(
          state.activityLocationSettingsDataSource.map((el) => {
            return {
              AirlineCode: airlineCode,
              AirportCode: el?.airportCode ?? "",
              LocationCode: el?.locationCode ?? "",
              CrewType: el?.crewType ?? 0,
              transporterId: el?.transporterId ?? 0,
              IsMapped: el?.isMapped ?? false,
              WefDate: el?.wefDate ?? "",
              UserName: userName,
            };
          }),
        ),
      ];
      const response = await axiosPost(
        `/CrewActivity/save-activity-location-settings`,
        {
          ActivityLocationMapping: activityLocationMappingData,
        },
      );
      isConfirmed = await showResponseMessageWithErrorInToast(response);
      if (isConfirmed) {
        await getActivityLocationSettings();
      }
      setState((prev) => ({ ...prev, isLocationMappingSubmitted: false }));
    } catch (err) {
      console.log(
        "Error in handleOnSaveActivityLocationSettings function",
        err,
      );
      setState((prev) => ({ ...prev, isLocationMappingSubmitted: false }));
    }
  };

  return (
    <div>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{ content: { width: "50%" } }}
        onAfterOpen={async () => {
          await fetchApiOnPageLoad();
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {state.dutyLocatonId === 0
              ? "Add Activity Location Mapping"
              : `Update Activity Location Mapping [${props.locationCode}]`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.onClose();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <DataGrid
            dataSource={state.activityLocationSettingsDataSource}
            columnsAutoWidth={true}
            showColumnLines={true}
            showRowLines={true}
            showBorders={true}
            rowAlternationEnabled={false}
            allowColumnResizing={true}
          >
            <Editing
              mode="cell"
              allowUpdating={true}
              allowAdding={false}
              allowDeleting={false}
            />
            <Column
              dataField="airportCode"
              caption="Airport Code"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              width={"15%"}
              allowEditing={false}
            />
            <Column
              dataField="crewType"
              caption="Crew Type"
              headerFilter={{ allowSearch: true }}
              allowSearch={true}
              width={"10%"}
              allowEditing={false}
            />
            <Column
              dataField="transporterId"
              caption="Service Provider"
              //calculateDisplayValue="transporterName"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
              width={"35%"}
            >
              <Lookup
                dataSource={state.serviceProviderGridDataSource}
                valueExpr="id"
                displayExpr="name"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
              />
            </Column>
            <Column
              dataField="wefDate"
              caption="Wef Date"
              width={"25%"}
              dataType="date"
              format="dd/MM/yyyy"
              allowSearch={true}
              headerFilter={{ allowSearch: true }}
            ></Column>
            <Column
              dataField="isMapped"
              caption="Mapped"
              headerFilter={{ allowSearch: true }}
              allowSearch={true}
              width={"10%"}
            />
            <SortByGroupSummaryInfo summaryItem="count" />
            <GroupPanel visible={false} />
            <HeaderFilter visible={true} />
            <SearchPanel
              visible={true}
              highlightCaseSensitive={true}
              width={240}
              placeholder="Search..."
            />
            <Grouping autoExpandAll={true} />
            <Paging defaultPageSize={10} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={[10, 20, 50]}
              showInfo={true}
              visible={true}
            />
            <Export
              enabled={true}
              allowExportSelectedData={false}
              fileName="ActivityLocationMapping"
            />
          </DataGrid>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Save"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnSaveActivityLocationSettings(e);
            }}
          >
            <i
              className={`fas fa-${
                state.isLocationMappingSubmitted ? "spinner fa-spin" : "check"
              }`}
            />
            &nbsp;Save
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            title="Cancel"
            className="btn btn-secondary btn-sm"
            onClick={() => {
              props.onClose();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;Close
          </button>
        </div>
      </Modal>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: "#historydiv" }}
        visible={state.loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        closeOnOutsideClick={false}
      />
    </div>
  );
});
